import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, showDeleteDialog, useSettings } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';

export default function PhonesErrorsView() {
	const { t } = useSettings();
	const dispatch = useDispatch();
	const intl = useIntl();

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	const columns: GridColDef[] = [
		{
			field: 'phon_title',
			headerName: t('DETAILS_PHONES_FIELD_TITLE'),
			minWidth: 200,
			flex: 2,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			sortable: false
		},
		{
			field: 'phon_description',
			headerName: t('DETAILS_PHONES_FIELD_DESCRIPTION'),
			minWidth: 200,
			flex: 2,
			renderCell: ViewTableUtils.renderCellWithTooltip,
			sortable: false,
			hideable: false
		},
		{
			field: 'user_title',
			headerName: t('PHONES_ERRORS_COLUMN_USER'),
			minWidth: 400,
			flex: 4,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'companies', uid: row.comp_uid } }),
			sortable: false
		},
		{
			field: 'error',
			headerName: t('PHONES_ERRORS_COLUMN_ERROR'),
			minWidth: 300,
			flex: 3,
			renderCell: ({ value, row }) =>
				ViewTableUtils.renderSquareChip({
					value: intl.formatMessage(
						{ id: 'phonesErrorView.error', defaultMessage: t(value) },
						{ country: row.ctry_title }
					),
					backgroundColor: theme => theme.palette.error.main
				}),
			sortable: false,
			hideable: false
		},
		{
			field: 'actions',
			type: 'actions',
			getActions: ({ row }) => [
				<GridActionsCellItem
					label="VIEW_ITEM_BUTTON_EDIT"
					icon={<Icon icon="edit" />}
					onClick={() =>
						dispatch(
							showFastAddDialog({
								module: 'phones',
								isUpdate: true,
								model: row,
								maxDialogWidth: 'sm',
								updateRefresh,
								additionalProps: { disableIdentityAssociation: true }
							})
						)
					}
				/>,
				<GridActionsCellItem
					label="VIEW_ITEM_BUTTON_DELETE"
					icon={<Icon icon="delete" />}
					onClick={() =>
						dispatch(
							showDeleteDialog({
								module: 'phones',
								id: row.phon_uid,
								title: row.phon_title,
								updateRefresh
							})
						)
					}
				/>
			]
		}
	];

	return (
		<ViewTable
			className="border-0"
			module="phones"
			query={{ storedProcedure: 'st_phones_errors_list' }}
			columns={columns}
			refresh={refresh}
			updateRefresh={updateRefresh}
			showExportButton={false}
		/>
	);
}
